import React from "react";
import {
  parseCommentDisplayParts,
  getDefaultMentionPillStyle,
} from "src/utils/commentMentions";
import { getCssColors } from "src/scss/theme";
import CommentLink from "src/components/general/CommentLink";
import "src/components/general/commentLinks.scss";

/**
 * Renderiza comentario con @menciones (email) resaltadas en pill y URLs como links.
 */
const CommentMentionText = ({ text, className, mentionStyle, mentionClassName = "comment-mention-pill" }) => {
  const { teal } = getCssColors();
  const pillStyle = { ...getDefaultMentionPillStyle(teal), ...mentionStyle };
  const parts = parseCommentDisplayParts(text);

  return (
    <span className={className} style={{ whiteSpace: "pre-wrap" }}>
      {parts.map((part, index) => {
        if (part.type === "mention") {
          return (
            <span
              key={`m-${index}`}
              className={mentionClassName}
              style={pillStyle}
            >
              {part.value}
            </span>
          );
        }
        if (part.type === "link") {
          return (
            <CommentLink
              key={`l-${index}`}
              href={part.href}
              label={part.label}
            />
          );
        }
        return <React.Fragment key={`t-${index}`}>{part.value}</React.Fragment>;
      })}
    </span>
  );
};

export default CommentMentionText;
